import { defineStore } from "pinia";

export const useAuth = defineStore("auth", {
  state: () => ({
    token: useCookie("customer_token", {
      sameSite: true,
      maxAge: 3 * 60 * 60,
    }),

    profile: null,
  }),

  actions: {
    setToken(token) {
      this.token = token;
    },

    setProfile(profile) {
      this.profile = profile;
    },

    signOut() {
      this.token = null;

      this.profile = null;
    },
  },

  getters: {
    signedIn(state) {
      return state.token !== null && state.profile !== null;
    },

    initials(state) {
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");

      let initials = [...state.profile.name.matchAll(rgx)] || [];

      return (
        (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
      ).toUpperCase();
    },
  },
});
